const ListPlaceholder = () => {
  return (
    <p className='card-text placeholder-glow'>
      <span className='placeholder h-30px rounded border-0 bg-gray mb-2'></span>
      <span className='placeholder h-30px rounded border-0 bg-gray mb-2'></span>
      <span className='placeholder h-30px rounded border-0 bg-gray mb-2'></span>
      <span className='placeholder h-30px rounded border-0 bg-gray mb-2'></span>
      <span className='placeholder h-30px rounded border-0 bg-gray mb-2'></span>
    </p>
  )
}

export default ListPlaceholder
